<script>
export default {
  props: [ 'amount' ],

  // eslint-disable-next-line vue/component-api-style
  methods: {
    formatNumber(value) {
      return new Intl.NumberFormat().format(value)
    },
  },
}
</script>

<template>
  <span class="numeric-value">
    {{ formatNumber(amount) }}
  </span>
</template>
